<template>
  <div style="margin: 0px; padding: 0px;">
    <span
      style="width: 200px; height: 200px; font-size:24px; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; margin: auto">
      支付宝登录页面跳转中。。。。。。
    </span>
    <div v-html="sHtmlText"></div>
  </div>
</template>
<script>
// import {setCookie,getCookie} from '../../assets/js/cookie.js'
import axios from 'axios';


export default {
  data() {
    return {
      sHtmlText: '',
    }
  },
  mounted() {
    this.getDate();
  },
  methods: {
    getDate() {
      location.href = 'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021006119659013&scope=auth_user&redirect_uri=https://wwww.2office.cn/alipayauth&state=alipaybind';
    },
  },
  // watch:{
  //     sHtmlText:function(newVal, oldVal){
  //         //console.log("oldVal:" + oldVal);
  //         if(newVal && newVal !=''){
  //             console.log(newVal);
  //             document.forms['alipaysubmit'].submit();
  //         }


  //     }
  // }


}
</script>



// WEBPACK FOOTER //
// src/components/alipaylogin/alipaybind.vue